import React from 'react'
import { Field } from 'formik'

import UploadField from '../../../shared/UploadField'

export const Forms = ({ errorMessage, label = 'Special Release Form' }) => (
  <>
    <Field
      component={UploadField}
      label={label}
      name="attachment"
      placeholder="Upload file"
      error={errorMessage('attachment')}
    />
  </>
)
